/* eslint-disable react-hooks/exhaustive-deps */
import { LessonsList } from './components/LessonsList';
import { usePublicLessonHook } from './hooks/usePublicLessonHook';

export const LessonsShareWithPublicPage = () => {
    const { loading, lessonData } = usePublicLessonHook();

    return <LessonsList loading={loading} lessonData={lessonData} />;
};
